import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { UserInfoService } from '../shared-resources/services/user-info.service';

@Injectable({
  providedIn: 'root',
})
export class OnDemandPreloadService {
  public subject = new Subject<string[]>();
  public routePath = [];

  constructor(private userInfo: UserInfoService) {
    this.userInfo.getUserInfo$().subscribe(() => {
      setTimeout(() => {
        this.startPreload(environment.preloadAfterLogin);
      }, 500);
    });
  }

  startPreload(modules: any): void {
    this.routePath = _.uniq(this.routePath.concat(modules));
    this.subject.next(this.routePath);
  }
}
